import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { loginRequest } from "../../authConfig";
import { getMSToken } from "services/auth-actions";
import { useAppDispatch } from "hooks";
import { ADD_AUTH_USER } from "../../redux/auth/authSlice";
import { jwtDecode } from "jwt-decode";

const Authenticator: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      if (!isAuthenticated) {
        instance.loginRedirect(loginRequest);
      } else if (isAuthenticated) {
        getAuthData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inProgress, isAuthenticated]);

  const getAuthData = async () => {
    const response = await getMSToken(instance);

    console.log("--response", response);
    if (!response || !response.accessToken) {
      instance.loginRedirect(loginRequest);
      return;
    }

    let expiresOn: Date = new Date();

    console.log("localExpiresOn", expiresOn);
    console.log("decodedjwt date", new Date(jwtDecode(response.accessToken).exp! * 1000));

    if (response.expiresOn) {
      // expiresOn = new Date(new Date().getTime() + response.expiresOn.getTime() * 1000);
      expiresOn = response.expiresOn;
    } else if (response.accessToken) {
      const decodedToken = jwtDecode(response.accessToken);
      expiresOn = new Date(decodedToken.exp! * 1000);
    }

    if (expiresOn && new Date() > expiresOn) {
      instance.loginRedirect(loginRequest);
      return;
    }
    const state = {
      auth: {
        msName: response?.account?.name || "",
        msUsername: response?.account?.username || "",
        msUserRoles: response?.account?.idTokenClaims?.roles || [], // Update the type to be an array of strings
        accessToken: response?.accessToken || "",
        idToken: response?.idToken || "",
        expiresOn: expiresOn.getTime() || 0,
        // expiresOn: 1000000000000000,
      },
    };

    dispatch(ADD_AUTH_USER({ auth: state.auth }));
  };

  return <>{children}</>;
};

export default Authenticator;
